module.exports = __webpack_public_path__ + "img/2.8d8cfb54.jpg";